import React, { useState, useEffect } from "react";
import QRCode from "qrcode.react";
import "../../styles/components/events-tv.css";
import { format } from "date-fns";
import { useAuth0 } from "@auth0/auth0-react";
import { getContentById } from "../../services/content-service";
import ContentThumbnail from "../content/content-thumbnail";
import { useNavigate } from "react-router-dom";

export default function EventCardTV({ event, eventId }) {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const [translatedName, setTranslatedName] = useState(event?.name || "");
  const [translatedDescription, setTranslatedDescription] = useState(event?.description || "");
  const [linkedContent, setLinkedContent] = useState(null);

  // Handle translations
  useEffect(() => {
    const language = localStorage.getItem("language") || "en";

    if (language === "en") {
      setTranslatedName(event?.name || "");
      setTranslatedDescription(event?.description || "");
    } else if (event?.translations) {
      const nameTranslation = event.translations.find(
        (t) => t.language === language && t.fieldName === "Name"
      );
      const descriptionTranslation = event.translations.find(
        (t) => t.language === language && t.fieldName === "Description"
      );

      setTranslatedName(nameTranslation?.contents || event?.name || "");
      setTranslatedDescription(descriptionTranslation?.contents || event?.description || "");
    }
  }, [event]);

  // Fetch linked content if available
  useEffect(() => {
    async function fetchLinkedContent() {
      if (!event?.linkedContentID) return;
      try {
        const token = await getAccessTokenSilently();
        const { data, error } = await getContentById(token, event.linkedContentID);
        if (!error) {
          setLinkedContent(data);
        }
      } catch (err) {
        console.error("Error fetching linked content:", err);
      }
    }

    fetchLinkedContent();
  }, [event?.linkedContentID, getAccessTokenSilently]);

  if (!event) {
    return <div>No event data available.</div>;
  }

  // Generate the URL for the QR code - link to normal event page
  const eventPageUrl = `https://family.dbacks.com/events/${eventId}`;

  return (
    <div className="event-card-tv">
      <div className="event-tv-top-bar">
        <button className="event-tv-back-btn" onClick={() => navigate('/calendar-tv')}>
          <i className="fa-solid fa-arrow-left"></i> Back
        </button>
        <img
          src="https://azdfmlyappsa.blob.core.windows.net/images/fmlyLogo.png"
          alt="Family Logo"
          className="event-tv-logo"
        />
      </div>
      <div className="event-tv-content">
        <div className="event-tv-details">
          <h1 className="event-tv-title">{translatedName}</h1>

          <p className="event-tv-date">
            <i className="fa-solid fa-calendar-heart"></i>
            {event?.date ? format(new Date(event.date), "PPpp") : "No date selected"}
          </p>

          <p className="event-tv-description">
            <i className="fa-solid fa-message-lines"></i>
            {translatedDescription}
          </p>

          {linkedContent && (
            <div className="event-tv-linked-content">
              <ContentThumbnail content={linkedContent} />
            </div>
          )}
        </div>

        <hr className="event-tv-divider" />

        <div className="event-tv-qr">
          <p className="event-tv-qr-label">Scan to RSVP &amp; View Details</p>
          <QRCode 
            value={eventPageUrl} 
            size={480}
            level="H"
            includeMargin={true}
            bgColor="#ffffff"
            fgColor="#141414"
          />
        </div>
      </div>
    </div>
  );
}
